import i18n from '../../i18n';

export const BOOKING_DOC_TYPES = [
  {
    label: i18n.t('bookingAddDocument.types.quotation'),
    value: 'quotation',
  },
  {
    label: i18n.t('bookingAddDocument.types.invoice'),
    value: 'invoice',
  },
  {
    label: i18n.t('bookingAddDocument.types.contract'),
    value: 'contract',
  },
  {
    label: i18n.t('bookingAddDocument.types.other'),
    value: 'other',
  },
];

/**
 * Get the booking document type translation.
 * @param {string} type - The booking document type.
 * @returns {string} - The booking document type translation.
 */
export const getBookingDocTypeTrad = (type) => {
  const found = BOOKING_DOC_TYPES.find((docType) => docType.value === type);
  return found ? found.label : '';
};
